import { render, staticRenderFns } from "./product_modal.vue?vue&type=template&id=17b94c25&scoped=true&"
import script from "./product_modal.vue?vue&type=script&lang=js&"
export * from "./product_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b94c25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b94c25')) {
      api.createRecord('17b94c25', component.options)
    } else {
      api.reload('17b94c25', component.options)
    }
    module.hot.accept("./product_modal.vue?vue&type=template&id=17b94c25&scoped=true&", function () {
      api.rerender('17b94c25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/product_modal.vue"
export default component.exports